var querystring = (function () {
        return {
            change: function (searchString, documentTitle) {
                documentTitle = typeof documentTitle !== 'undefined' ? documentTitle : document.title;
                var urlSplit = (window.location.href).split("?");
                var obj = {
                    Title: documentTitle,
                    Url: urlSplit[0].replace(/\/+$/, '') + '?' + searchString
                };
                history.pushState(obj, obj.Title, obj.Url);
            }
        };
    })();
    
    //reload page after change history via browser
    //REFERENCE: https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
    window.onpopstate = function () {
        document.location.reload();
    };
export default querystring;